// extracted by mini-css-extract-plugin
export var heroImage = "_bx-1";
export var modal = "_bx-0";